import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

export default function dayjsFormat(time, formatString /*, positionalB, named*/) {
  dayjs.extend(advancedFormat);
  return dayjs(time).format(formatString)
}
